export default __webpack_public_path__ + "897db8deefb90677f7b491b9ab53a7ef.woff";